import { atom } from "../../app-jotai";

import type { PdfUploadResponse } from "./types/pdfFileResponse";
export const emptyFile: PdfUploadResponse = {
  filename: "",
  pages: [],
  totalPages: 0,
};
export const WhiteboardFileAtom = atom<PdfUploadResponse[]>([
  emptyFile, // previous file
  emptyFile, // current file
]);

export class PdfFileController {
  constructor(private pdfFiles: PdfUploadResponse[]) {}

  get currentFile(): PdfUploadResponse {
    return this.pdfFiles[this.pdfFiles.length - 1];
  }
  get previousFile(): PdfUploadResponse {
    return this.pdfFiles[this.pdfFiles.length - 2];
  }
  get currentFileIsSameAsPreviousFile(): boolean {
    return this.currentFile.filename === this.previousFile.filename;
  }

  get isCurrentFileEmpty() {
    return this.currentFile.pages.length <= 0;
  }

  static addFile(
    prev: PdfUploadResponse[],
    file: PdfUploadResponse,
  ): PdfUploadResponse[] {
    const prevFiles = this.getAllFiles(prev);
    if (this.hasFile(file.filename, prevFiles)) {
      const files = prevFiles.filter((f) => f.filename !== file.filename);
      return [...files, file];
    }

    return [...prevFiles, file].slice(-3);
  }
  /**
   * remove file from pdfFiles array but not update the whiteboard
   */
  static _removeFile(
    prev: PdfUploadResponse[],
    file: PdfUploadResponse,
  ): PdfUploadResponse[] {
    const prevFiles = this.getAllFiles(prev);
    if (!this.hasFile(file.filename, prevFiles)) {
      return prevFiles;
    }
    return prevFiles.filter((f) => f.filename !== file.filename);
  }
  static getAllFiles(pdfFiles: PdfUploadResponse[]) {
    return [...new Set(pdfFiles.filter((file) => file.totalPages !== 0))];
  }

  static removeCurrentFile(pdfFiles: PdfUploadResponse[]) {
    return this.addFile(pdfFiles, emptyFile);
  }
  static hasFile(name: string, pdfFiles: PdfUploadResponse[]) {
    return pdfFiles.some((file) => file.filename === name);
  }
}
